var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWlanSvc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6797 15.6581C36.4254 16.3035 36.5066 17.4313 35.8612 18.1769L23.4951 32.4626C23.1726 32.8352 22.7106 33.0579 22.2183 33.0781C21.726 33.0984 21.2472 32.9143 20.8953 32.5695L15.4042 27.1901C14.6997 26.4999 14.6881 25.3693 15.3783 24.6648C16.0685 23.9603 17.1991 23.9487 17.9035 24.6389L22.0379 28.6892L33.1609 15.8395C33.8063 15.0938 34.9341 15.0126 35.6797 15.6581Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8471 1.0954C25.3143 0.884378 25.8497 0.884378 26.317 1.0954C35.1949 5.10483 39.1803 6.38583 49.0107 8.14919C49.8201 8.29439 50.4257 8.97363 50.4775 9.79437C52.3648 39.7059 28.0904 50.0653 26.2491 50.8068C25.8211 50.9792 25.343 50.9792 24.915 50.8068C23.0736 50.0653 -1.2007 39.7059 0.68654 9.79437C0.738324 8.97363 1.34394 8.29439 2.15339 8.14919C11.9838 6.38583 15.9691 5.10483 24.8471 1.0954ZM4.18282 11.4093C3.34085 35.7719 21.6024 45.4015 25.582 47.2063C29.5617 45.4015 47.8232 35.7719 46.9812 11.4093C38.0977 9.76016 33.8008 8.3635 25.582 4.68088C17.3632 8.3635 13.0664 9.76016 4.18282 11.4093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlanSvc2);
export default __webpack_public_path__ + "static/media/wlan_svc2.bd93ad0188bdb62b2748d24177e72212.svg";
export { ForwardRef as ReactComponent };